import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/zh-cn';
dayjs.extend(utc);
dayjs.extend(timezone);
// 全局中文：antd DatePicker/RangePicker 日历文案随 dayjs 全局 locale（ConfigProvider
// locale 只管按钮/占位）。设为 zh-cn 让日期选择面板整体中文。
dayjs.locale('zh-cn');
export const BJ = 'Asia/Shanghai';
export const nowBJ = () => dayjs().tz(BJ);
export const bj = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ);
export const startOfDayISO = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ).startOf('day').toISOString();
export const endOfDayISO = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ).endOf('day').toISOString();
export const dateStrBJ = (d?: dayjs.ConfigType) => dayjs(d).tz(BJ).format('YYYY-MM-DD');
export const fmtBJ = (d?: dayjs.ConfigType, pattern = 'YYYY-MM-DD HH:mm:ss') => (d ? dayjs(d).tz(BJ).format(pattern) : '');
